/**
 * @fileoverview DELETE handler for the "/alloys/:partner/attribution/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAlloysPartnerAttributionAppGroupIdCacheKeys } from "./constants";
import type {
  DeleteAlloysPartnerAttributionAppGroupIdProps,
  DeleteAlloysPartnerAttributionAppGroupIdResult,
} from "./types";

export const deleteAlloysPartnerAttributionAppGroupId = reactQueryMutationAdapter(
  deleteAlloysPartnerAttributionAppGroupIdCacheKeys,
  (
    props: DeleteAlloysPartnerAttributionAppGroupIdProps
  ): Promise<DeleteAlloysPartnerAttributionAppGroupIdResult> => {
    return fetch(`/alloys/${props.partner}/attribution/${props.appGroupId}`, "DELETE", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
